import { render, staticRenderFns } from "./ProductRow.vue?vue&type=template&id=0f6c3409&scoped=true&"
import script from "./ProductRow.vue?vue&type=script&lang=js&"
export * from "./ProductRow.vue?vue&type=script&lang=js&"
import style0 from "./ProductRow.vue?vue&type=style&index=0&id=0f6c3409&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6c3409",
  null
  
)

export default component.exports